

































import { Component, Prop, Vue } from 'vue-property-decorator';
import ApiRequest from '@/util/apiRequest';
import { API_MOTION_SEARCH } from '@/util/config';
import MotionSearchItem from '@/components/MotionSearchItem.vue';
import PagePicker from '@/components/PagePicker.vue';

export default Vue.extend({
  name: 'MotionSearchView',
  props: {
    query: {},
  },
  data: () => ({
    motions: undefined,
    perPage: 25,
    startingAt: 0,
    numMotions: 0,
  }),
  components: {
    MotionSearchItem,
    PagePicker,
  },
  methods: {
    async runQuery() {
      this.rationalisePageValues();

      const ourQuery = this.$props.query;
      ourQuery.startFrom = this.startingAt;
      ourQuery.numberResults = this.perPage;
      const response = await ApiRequest.Post(API_MOTION_SEARCH, ourQuery);
      this.$data.motions = response.results;
      this.$data.numMotions = response.countResults;
    },
    rationalisePageValues() {
      if (this.startingAt < 0) {
        this.startingAt = 0;
      }
    },
  },
  watch: {
    query: 'runQuery',
    perPage: 'runQuery',
    startingAt: 'runQuery',
  },
  mounted() {
    this.runQuery();
  },
  computed: {
    currentPage() {
      return Math.floor(this.$data.startingAt / this.$data.perPage) + 1;
    },
    lastPage() {
      return Math.ceil(this.$data.numMotions / this.$data.perPage);
    },
  },
});
